import { Centrifuge, type Options, type TransportEndpoint } from 'centrifuge'
import { injectable } from 'inversify'

@injectable()
export default class CentrifugeClient {
  public create(endpoint: string | Array<TransportEndpoint>, options?: Partial<Options>) {
    return new Centrifuge(endpoint, options)
  }
}
